import * as Yup from 'yup';

import { phoneRegex } from '../../utils/utils';

export const WarehouserSchema = Yup.object().shape({
  firstName: Yup.string().min(1).required('firstname is required'),
  lastName: Yup.string().min(1).required('Lastname is required'),
  userName: Yup.string().min(1).required('Name is required'),
  email: Yup.string().email().required('Email is required'),
  phoneNumber: Yup.string()
    .matches(phoneRegex, 'Invalid Nigerian phone number')
    .required('Phone number is required'),
  warehouseId: Yup.string().min(1).required('warehouse id is required'),
  role: Yup.string().min(1).required('Role is required'),
});

export type WarehouserDataType = Yup.InferType<typeof WarehouserSchema>;

type InitialValues = {
  firstName: string;
  lastName: string;
  userName: string;
  email: string;
  phoneNumber: string;
  warehouseId: string;
  role: string;
};

export const WarehouserInitialValues: InitialValues = {
  firstName: '',
  lastName: '',
  userName: '',
  email: '',
  phoneNumber: '',
  warehouseId: '',
  role: '',
};

export interface IWarehouserResponse {
  // contactEmail: string;
  // contactPerson: string;
  // contactPhoneNo: string;
  // createdBy: string;
  // createdDate: string;
  // createdRackCount: number;
  // id: string;
  // lastUpdatedBy: string;
  // name: string;
  // rackCount: number;
  // status: boolean;
  // type?: string | null;
  // updatedDate?: string | null;
  // warehouseAddress: string;
  // email: string;
  // userName: string;
}

export interface IWarehouserRequest {
  firstName: string;
  lastName: string;
  userName: string;
  email: string;
  phoneNumber: string;
  warehouseId: string;
  role: string;
}

// export interface IWarehouserListData {
//   contactEmail: string;
//   contactPerson: string;
//   contactPhoneNo: string;
//   createdBy: string;
//   createdDate: string;
//   createdRackCount: number;
//   id: string;
//   lastUpdatedBy: string;
//   name: string;
//   rackCount: number;
//   status: boolean;
//   type?: string | null;
//   updatedDate?: string | null;
//   warehouseAddress: string;
//   email: string;
//   userName: string;
// }

// export interface IWarehouserRequestResponse {
//   records: IWarehouserListData[];
//   totalPages: number;
//   totalRecords: number;
// }
